import { after_tool } from "../styles";
import WhatsappButton from "../Buttons/WhatsappButton";
import MailButton from "../Buttons/MailButton";
import { Row } from "react-grid-system";
import React, { Component } from 'react';



function TextTerms() {
    return (
        <div>
         <p style={after_tool}></p>
         <p>בייביסיטר מיוחד במינו בשיתוף 'עדי בשבילכם' מציע חיבור בין הורים לילדים מיוחדים לבייביסיטרים פוטנציאלים מתחום החינוך המיוחד.</p>
         <p>את הפרוייקט "בייביסיטר מיוחד במינו" הקימה הגב' נעמי אבנר - אמא לילד עם פגיעה מוחית קשה, אשר ראתה את הצורך בבייביסיטר להורים לילדים מיוחדים, ורתמה סטודנטיות לחינוך מיוחד לפיתוח והפעלת הפרויקט.</p>
         <p>מטרת הפרויקט היא להרחיב את מאגר הבייביסיטרים וכך לאפשר למספר מירבי של הורים לילדים מיוחדים, רווחה ומרווח נפשי, והאפשרות להשקיע בעצמם בזמן שהם יודעים שילדיהם נמצאים בידיים טובות.</p>
         <p>
           <div>לשאלות נוספות אתם מוזמנים לפנות אלינו באחת מהדרכים הבאות:</div>
           <Row height="80%">
             <div className="buttons_style">
               <MailButton attributes="bbmeyuchad@gmail.com"/>
               <WhatsappButton attributes="0556876741" qa="true"/>
             </div>
           </Row>
         </p>
         <p>
         <div>בברכה,</div>
         <div>צוות בייביסיטר מיוחד במינו,</div>
         <div>בשיתוף "עדי בשבילכם"</div>
         </p>
         <p><b>תנאי שימוש באפליקציה</b></p>

         <div>בייביסיטר מיוחד במינו מהווה פלטפורמה בלבד למציאת בייביסיטר מתאים לילדים עם צרכים מיוחדים.</div>
         <div>הצוות המנהל מסיר כל אחריות על איכות הבייביסיטר וכנ"ל על המשפחה הפונה.</div>
         <div>טיב הקשר בין המשפחה הפונה לבייביסיטר, על דעתם בלבד.</div>
         <div>התשלום על השירות, נקבע על פי סיכום מראש בין ההורה לבייביסיטר.</div>
     <p></p>    
     </div>
    );
}
export default TextTerms;
